import { jsxs as y, jsx as o } from "react/jsx-runtime";
import { c as k } from "../index-BHH_LiBO.js";
import { c as x } from "../index-rKuIKazb.js";
import g from "../IconLookup/index.js";
import A from "../Link/index.js";
import N from "../Text/index.js";
import { useTheme as L } from "../ThemeProvider/index.js";
import '../assets/index10.css';const T = "_layout_6y00w_2", X = "_withArrow_6y00w_17", b = "_text_6y00w_21", j = "_icon_6y00w_27", v = "_dark_6y00w_35", t = {
  layout: T,
  withArrow: X,
  text: b,
  icon: j,
  dark: v
}, q = (c) => {
  const {
    children: i,
    className: m,
    CustomLink: l,
    dataAaa: u,
    dataProductSlug: w,
    href: r,
    iconX: s,
    size: _ = "dog",
    target: n,
    to: d,
    withArrow: a
  } = c, f = L(), h = x(
    t[f],
    t.layout,
    a && t.withArrow,
    m
  ), p = (() => {
    if (n) return n;
    if (r) return "_blank";
  })(), e = (() => {
    if (s) return s;
    if (a) return k;
  })();
  return /* @__PURE__ */ y(
    A,
    {
      className: h,
      CustomLink: l,
      dataAaa: u,
      dataProductSlug: w,
      href: r,
      target: p,
      to: d,
      children: [
        /* @__PURE__ */ o(N, { className: t.text, size: _, weight: "bold", children: i }),
        e ? /* @__PURE__ */ o("div", { className: t.icon, children: /* @__PURE__ */ o(g, { iconX: e }) }) : null
      ]
    }
  );
};
export {
  q as default
};
